import { Component, Inject, Input } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogContent } from '@angular/material/dialog';
import { Post } from '../../interfaces/post.interface';
import { CollaborationService } from '../../services/collaboration.service';
import { NgClass } from '@angular/common';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { QuillRTEComponent } from '../quill-rte/quill-rte.component';
import { AssetUrlPipe } from '../../pipes/asset-url.pipe';
@Component({
    selector: 'app-post-edit-dialog',
    templateUrl: './post-edit-dialog.component.html',
    styleUrl: './post-edit-dialog.component.scss',
    imports: [NgClass, CdkScrollable, MatDialogContent, QuillRTEComponent, AssetUrlPipe]
})
export class PostEditDialogComponent {
  dialogData: any;
  placeHolder;
  constructor(
    public dialogRef: MatDialogRef<PostEditDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: Post,
    public collaborationService: CollaborationService
  ) { }

  ngOnInit() {
    this.dialogData = this.data;
    if (this.dialogData?.isComment) {
      this.placeHolder = "Your comment..."
    }
  }

  close() {
    this.dialogRef.close(false);
  }

  send(data: { text: string, id: string }) {
    this.dialogRef.close(data);
  }

}
